import React from 'react'
import { connect } from 'react-redux'
import { Modal, Button } from 'react-bootstrap'
import { hideModal } from '../../redux/actions/uiActions'
import { API_URL } from '../../config'

const ModalDialog = ({ modal, hideModal}) => {
  const { isModalVisible, title, path, nss} = modal
  
  return (
    <Modal
        show={isModalVisible}
        onHide={hideModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {title}
            {nss && <span class="ml-1 badge badge-dark">NSS: {nss}</span>}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe 
              title="documento"
              width="100%"
              height="500"
              src={`${API_URL}${path}?token=${sessionStorage.getItem('token')}`}>
          </iframe>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={hideModal}>Cerrar</Button>
        </Modal.Footer>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  modal : state.uiReducer
})

const mapDispatchToProps = {
  hideModal
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalDialog)